export type PrimaryColorConfig = {
  name?: string
  light?: string
  main: string
  dark?: string
}

// Primary color config object
const primaryColorConfig: PrimaryColorConfig[] = [
  {
    name: 'primary',
   light: '#000000',
    main: '#000000',
    dark: '#000000'
  },
  {
    name: 'secondary',
    light: '#DA291C',
    main: '#DA291C',
    dark: '#DA291C'
  },   
]

export default primaryColorConfig
